import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalStatsBar = ({ stats, loading }) => {
  const cards = [
    {
      label: 'Pending Approvals',
      value: loading ? '—' : stats?.pending ?? 0,
      icon: 'Clock',
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      border: 'border-amber-200',
    },
    {
      label: 'Overdue',
      value: loading ? '—' : stats?.overdue ?? 0,
      icon: 'AlertTriangle',
      color: 'text-red-600',
      bg: 'bg-red-50',
      border: 'border-red-200',
    },
    {
      label: 'Approved (30d)',
      value: loading ? '—' : stats?.approved ?? 0,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bg: 'bg-green-50',
      border: 'border-green-200',
    },
    {
      label: 'Approval Rate',
      value: loading ? '—' : `${stats?.approvalRate ?? 0}%`,
      icon: 'TrendingUp',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      border: 'border-blue-200',
    },
    {
      label: 'Avg Response',
      value: loading ? '—' : stats?.avgResponseTime ?? '—',
      icon: 'Timer',
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      border: 'border-purple-200',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
      {cards?.map((card) => (
        <div
          key={card?.label}
          className={`bg-card border ${card?.border} rounded-xl p-4 flex items-center gap-3`}
        >
          <div className={`w-10 h-10 rounded-lg ${card?.bg} flex items-center justify-center flex-shrink-0`}>
            <Icon name={card?.icon} size={20} color={card?.color?.replace('text-', '')?.replace('-600', '')} className={card?.color} />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground font-medium truncate">{card?.label}</p>
            <p className={`text-xl font-bold ${card?.color}`}>{card?.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ApprovalStatsBar;
